module.exports = __webpack_public_path__ + "site/img/26.ccb39e89.jpg";